

export default class BaseFirebaseRepository {

    removeCallback = (callbackKey, context) => {
        if (this.callbackMap[callbackKey]) {
            delete this.callbackMap[callbackKey];
        }
        if (this.childAddedCallbackMap[callbackKey]) {
            delete this.childAddedCallbackMap[callbackKey];
        }
        if (context) {
            if (this.contextCallbackMap.get(context)) {
                let callbackKeys = Object.keys(this.contextCallbackMap.get(context))
                callbackKeys.forEach((key) => {
                    if (this.callbackMap[key]) {
                        delete this.callbackMap[key];
                    }
                })
                this.contextCallbackMap.delete(context)
            }

            this.removeSingleItemCallback(null, null, context)
            this.removeCallbackFromWeakMap(this.childAddedContextCallbackMap, this.childAddedCallbackMap, callbackKey, context)
        }
    }

    removeCallbackFromWeakMap = (contextWeakMap, callbackMap, callbackKey, context) => {
        if (callbackKey && id && callbackMap[id] && callbackMap[id][callbackKey]) {
            delete callbackMap[id][callbackKey]
        }
        if (context) {
            let contextCallbackMap = contextWeakMap.get(context)
            if (contextCallbackMap) {
                // Remove all callbacks of the given context
                let callbackGroupIds = Object.keys(contextCallbackMap)
                callbackGroupIds.forEach((callbackGroupId) => {
                    delete callbackMap[callbackGroupId]
                })
                contextWeakMap.delete(context)
            }
        }
    }
    removeSingleItemCallback = (callbackKey, id, context) => {
        if (callbackKey && id && this.singleItemCallbackMap[id][callbackKey]) {
            delete this.singleItemCallbackMap[id][callbackKey]
        }
        if (context) {
            let contextCallbackMap = this.singleItemContextCallbackMap.get(context)
            if (contextCallbackMap) {
                if (!id) {
                    // Remove all callbacks of the given context
                    let callbackGroupIds = Object.keys(contextCallbackMap)
                    callbackGroupIds.forEach((callbackGroupId) => {
                        if (this.singleItemCallbackMap[callbackGroupId]) {
                            let callbackKeys = Object.keys(this.singleItemCallbackMap[callbackGroupId])
                            callbackKeys.forEach(key => {
                                if (this.singleItemCallbackMap[callbackGroupId][key]) {
                                    delete this.singleItemCallbackMap[callbackGroupId][key];
                                }
                            })
                        }
                    })
                    this.singleItemContextCallbackMap.delete(context)
                }
                else {
                    // Remove all callbacks related to the given id
                    if (!this.singleItemContextCallbackMap.get(context) || !this.singleItemContextCallbackMap.get(context)[id]) {
                        return
                    }
                    let callbackKeys = Object.keys(this.singleItemContextCallbackMap.get(context)[id])
                    callbackKeys.forEach((key) => {
                        if (this.singleItemCallbackMap[id]) {
                            if (this.singleItemCallbackMap[id][key]) {
                                delete this.singleItemCallbackMap[id][key];
                            }
                        }
                    })
                }
            }
        }
    }

    constructor(app) {
        this.app = app
        // Store which menu item's images had been loaded
        this.allItems = []
        this.singleLoadedItems = {}
        this.childAddedCallbackMap = {}
        this.childRemovedCallbackMap = {}
        this.callbackMap = {}
        this.singleItemCallbackMap = {}
        this.loadedItemIds = []
        this.contextCallbackMap = new WeakMap()
        this.childAddedContextCallbackMap = new WeakMap()
        this.childRemovedContextCallbackMap = new WeakMap()
        this.singleItemContextCallbackMap = new WeakMap()

        // Store the throttle time by callback key
        this.onThrottledResultByGroupTimer = {}

        // To handle API load data
        this.autoAbort = true
    }

    abort = () => {
        this.request && this.request.abort()
    }

    /**
     * Return the Firebase query
     */
    getRef = () => {
        throw "Please implement 'getRef()' method in your subclass"
    }

    /**
     * Return the Firebase query for single item query
     */
    getSingleRef = () => {
        throw "Please implement 'getSingleRef()' method in your subclass"
    }

    /**
     * After object data has been loaded from Firebase,
     * we will attempt to "update" the object property into
     * object create from this method
     */
    getBaseObject = () => {
        throw "Please implement this method in your subclass"
        // Example
        // return new OrderItem()

        // Or if you just need a plain object
        // return {}
    }

    /**
     * Once we get the result from Firebase, will use this to preprocess the
     * data before pass assign the data to getBaseObject()
     */
    preprocessItem = (rawFirebaseData) => {
        return rawFirebaseData
    }

    /**
     * Parse raw API response before perform any logic
     * @returns {Object}
     */
    parseRawApiResponse = (rawResponse) => {
        return rawResponse
    }
    /**
     * If need to custom sort the data after loaded from
     * Firebase, return the sort function here. Need to be compatible
     * with JS Array.sort()
     */
    sort = () => {
        return null
    }

    setCallback = (id, callback, callbackKey, context) => {
        if (typeof callbackKey === 'undefined') {
            throw "You must pass a valid callbackKey to loadOne()"
        }
        if (callback && callbackKey) {
            if (!this.singleItemCallbackMap[id]) {
                this.singleItemCallbackMap[id] = {}
            }
            if (context) {
                // Insert the callbackKey to HashMap, so that can be easily add/remove without duplicate.
                // Using an array to store is fine too, but we need to take care of duplicates
                if (!this.singleItemContextCallbackMap.get(context)) {
                    this.singleItemContextCallbackMap.set(context, {})
                }
                if (!this.singleItemContextCallbackMap.get(context)[id]) {
                    this.singleItemContextCallbackMap.get(context)[id] = {}
                }
                this.singleItemContextCallbackMap.get(context)[id][callbackKey] = true
            }
            this.singleItemCallbackMap[id][callbackKey] = callback
        }
    }
    loadOne = (id, callback, callbackKey, context) => {
        if (this.isUseAPI) {
            this.loadOneByApi(id, callback, callbackKey, context)
            return
        }
        this.setCallback(id, callback, callbackKey, context)
        const getRef = () => {
            return this.getSingleRef()
            .equalTo(id)
        }
        if (this.loadedItemIds.indexOf(id) === -1) {
            this.loadedItemIds.push(id)
            // We are loading single node only, no need to worry about
            // optimization
            getRef()
            .on('value', snapshot => {
                snapshot.forEach(childSnapshot => {
                    let item = childSnapshot.val()
                    item.key = childSnapshot.key
                    item = this.preprocessItem(item)
                    this.singleLoadedItems[id] = Object.assign(this.getBaseObject(), item)
                })
                this.triggerSingleItemCallback(id)
            })
            return
        }
        this.triggerSingleItemCallback(id,callbackKey)
    }

    /**
     * Some models are not suitable to be loaded via API, so we use
     * API to load the models
     *
     * @param {String} id
     * @param {Function} callback
     * @param {String} callbackKey
     * @param {Object} context
     * @returns
     */
    loadOneByApi = (id, callback, callbackKey, context) => {
        if (callback && callbackKey) {
            if (!this.singleItemCallbackMap[id]) {
                this.singleItemCallbackMap[id] = {}
            }
            if (context) {
                // Insert the callbackKey to HashMap, so that can be easily add/remove without duplicate.
                // Using an array to store is fine too, but we need to take care of duplicates
                if (!this.singleItemContextCallbackMap.get(context)) {
                    this.singleItemContextCallbackMap.set(context, {})
                }
                if (!this.singleItemContextCallbackMap.get(context)[id]) {
                    this.singleItemContextCallbackMap.get(context)[id] = {}
                }
                this.singleItemContextCallbackMap.get(context)[id][callbackKey] = true
            }
            this.singleItemCallbackMap[id][callbackKey] = callback
        }
        if (this.loadedItemIds.indexOf(id) === -1) {
            this.loadedItemIds.push(id)
            // This part by default is load from Firebase, now we modify to load
            // from API
            const fireSingleItemApi = () => {
                $.ajax({
                    url     : this.getApiUrl(id),
                    success : (res) => {
                        res = this.parseRawApiResponse(res)

                        // Though we load single item, but the response can be array, process each item in the array
                        if (Array.isArray(res)) {
                            let data = []
                            for (let i = 0; i < res.length; i++) {
                                let item = res[i]
                                item.key = res[i].id
                                item = this.preprocessItem(item)
                                item = Object.assign(this.getBaseObject(), item)
                                data.push(item)
                            }
                            this.singleLoadedItems[id] = data
                            this.triggerSingleItemCallback(id)
                        }
                        else {
                            let item = res
                            item.key = res.id
                            item = this.preprocessItem(item)
                            this.singleLoadedItems[id] = Object.assign(this.getBaseObject(), item)
                            this.triggerSingleItemCallback(id)
                        }
                    }
                })
            }


            const reloadEventKey = this.getSingleItemReloadEventKey(id)
            if (reloadEventKey) {
                $(document).on(reloadEventKey, fireSingleItemApi)
            }

            // Fire the API to load data
            fireSingleItemApi()
            return
        }
        this.triggerSingleItemCallback(id,callbackKey)
    }
    getApiBaseUrl = (id) => {
        return base_url_api
    }
    getApiUrl = (id) => {
        return this.getApiBaseUrl(id).replace("%id%", id)
    }
    getUpdateUrl = (id) => {
        return this.getApiBaseUrl(id) + "/update"
    }

    // Minimum interval where can we fire the reload API consecutively
    reloadDataEventThrottleTime = () => {
        return 1000
    }

    // The event that shall trigger the reload of data
    getReloadEventKey = () => {
        return null
    }

    // By default single item do not need to trigger reload by event
    getSingleItemReloadEventKey = (id) => {
        return null
    }

    getDataChangedEventKey = () => {
        return null
    }

    /**
     * Perform on demand server side search of data without caching.
     * From the result, will auto update the main data set also
     */
    loadSome = (filterData, callback, options) => {
        if (callback) {
            const noCache = options?.noCache
            $.ajax({
                url     : this.getApiUrl('all'),
                data    : filterData,
                success : (res) => {
                    let searchResultSet = []
                    res = this.parseRawApiResponse(res)

                    if (!Array.isArray(res)) {
                        res = [res]
                    }
                    res.forEach(item => {
                        item.key = res.id
                        item = this.preprocessItem(item)
                        item = Object.assign(this.getBaseObject(), item)
                        searchResultSet.push(item)
                    })

                    if (!noCache) {
                        searchResultSet.forEach(item => {
                            this.updateMainDataSet(item)
                        })
                        this.sortDataSet()
                    }
                    callback && callback(searchResultSet)
                }
            })
        }
    }
    onChildRemoved = (callback, callbackKey, context) => {
        if (callback && callbackKey ) {
            this.childRemovedCallbackMap[callbackKey] = callback
            if (context) {
                // Insert the callbackKey to HashMap, so that can be easily add/remove without duplicate.
                // Using an array to store is fine too, but we need to take care of duplicates
                if (!this.childRemovedContextCallbackMap.get(context)) {
                    this.childRemovedContextCallbackMap.set(context, {})
                }
                this.childRemovedContextCallbackMap.get(context)[callbackKey] = true
            }
        }

        if (this.firebaseListenerAdded) {
            // Nothing to do here as will only fire the callback on child removed
        }
        else {
            this.addFirebaseListeners()
        }
    }

    onChildAdded = (callback, callbackKey, context) => {
        if (callback && callbackKey ) {
            this.childAddedCallbackMap[callbackKey] = callback
            if (context) {
                // Insert the callbackKey to HashMap, so that can be easily add/remove without duplicate.
                // Using an array to store is fine too, but we need to take care of duplicates
                if (!this.childAddedContextCallbackMap.get(context)) {
                    this.childAddedContextCallbackMap.set(context, {})
                }
                this.childAddedContextCallbackMap.get(context)[callbackKey] = true
            }
        }

        if (this.firebaseListenerAdded) {
            // 1. Items already loaded, trigger specific callback
            // 2. Items being loaded, trigger specific callback first, on Firebase events,
            //    all callbacks will be fired again with the latest data
            this.triggerChildAddedCallback(null, callbackKey)
        }
        else {
            this.addFirebaseListeners()
        }
    }

    logChildRemoved = (item) => {
        console.log(`${this.constructor.name} - Child removed, ${item.id}`)
    }

    /**
     * callback - callback after items are loaded, will be called on items list changed
     * callbackKey - A string key used to identify the "callback", so that can be used to remove the callback when no needed
     * context - An object/string used to identify groups of callback so that multiple callbacks associated with the context can be removed easily
     */
    loadAll = (callback, callbackKey, context, queryParams) => {
        if (this.isUseAPI) {
            this.loadAllByApi(callback, callbackKey, context, queryParams)
            return
        }
        if (callback && callbackKey ) {
            this.callbackMap[callbackKey] = callback
            if (context) {
                // Insert the callbackKey to HashMap, so that can be easily add/remove without duplicate.
                // Using an array to store is fine too, but we need to take care of duplicates
                if (!this.contextCallbackMap.get(context)) {
                    this.contextCallbackMap.set(context, {})
                }
                this.contextCallbackMap.get(context)[callbackKey] = true
            }
        }
        if (this.firebaseListenerAdded) {
            // 1. Items already loaded, trigger specific callback
            // 2. Items being loaded, trigger specific callback first, on Firebase events,
            //    all callbacks will be fired again with the latest data
            this.triggerCallback(callbackKey)
        }
        else {
            this.addFirebaseListeners()
        }
    }
    reloadData = () => {
        const reloadEventKey = this.getReloadEventKey()
        if (reloadEventKey) {
            $(document).trigger(reloadEventKey)
        }
    }
    loadAllByApi = (callback, callbackKey, context, queryParams) => {
        if (callback && callbackKey ) {
            this.callbackMap[callbackKey] = callback
            if (context) {
                // Insert the callbackKey to HashMap, so that can be easily add/remove without duplicate.
                // Using an array to store is fine too, but we need to take care of duplicates
                if (!this.contextCallbackMap.get(context)) {
                    this.contextCallbackMap.set(context, {})
                }
                this.contextCallbackMap.get(context)[callbackKey] = true
            }
        }
        if (this.loadAllApiTriggered) {
            // 1. Items already loaded, trigger specific callback
            // 2. Items being loaded, trigger specific callback first, on Firebase events,
            //    all callbacks will be fired again with the latest data
            this.triggerCallback(callbackKey, true)
        }
        else {
            // Mark that we already fired API, future request no need
            // fire API but instead use cached values
            this.loadAllApiTriggered = true

            const fireApi = () => {
                let data = queryParams ? queryParams : {}
                $.ajax({
                    url     : this.getApiUrl('all'),
                    data    : data,
                    success : (res) => {
                        this.allItems = []
                        res = this.parseRawApiResponse(res)
                        if (Array.isArray(res)) {
                            res.forEach(item => {
                                item.key = res.id
                                item = this.preprocessItem(item)
                                this.allItems.push(Object.assign(this.getBaseObject(), item))
                            })
                        }
                        else {
                            this.allItems = [res]
                        }
                        this.doneLoadFromApi = true
                        this.triggerCallback(null, true)
                    }
                })
            }

            const throttleApi = () => {
                const throttleTime = this.reloadDataEventThrottleTime()
                if (throttleTime) {
                    if (!this.reloadThrottleTimer) {

                        // No throttle timer yet,
                        // Fire API now
                        hasPendingReload = false
                        fireApi()

                        // Set timer to delay next API
                        this.reloadThrottleTimer = setTimeout(() => {
                            this.reloadThrottleTimer = null
                            if (hasPendingReload) {
                                throttleApi()
                            }
                        }, throttleTime)
                    }
                    else {
                        // Already has throttle timer, so we just mark that need to fire API
                        // after time expired
                        hasPendingReload = true
                    }
                }
                else {
                    fireApi()
                }
            }

            let hasPendingReload = false
            const reloadEventKey = this.getReloadEventKey()
            if (reloadEventKey) {
                $(document).on(reloadEventKey, () => {
                    throttleApi()
                })
            }

            // Fire the API to load data
            throttleApi()
        }
    }

    addFirebaseListeners = () => {
        this.firebaseListenerAdded = true
        this.doneLoadValue = false

        this.getRef()
        .on('child_added', snapshot => {
            if (!this.doneLoadValue) {
                // We wait for 'value' listener to trigger first to initialize the
                // orders array. Adding item one by one from 'child_added' to initialize
                // orders array will trigger excessive and unnecessary render()
                return
            }

            let item = snapshot.val()
            item.key = snapshot.key
            item = this.preprocessItem(item)
            this.allItems.push(Object.assign(this.getBaseObject(), item))
            this.triggerCallback()
            this.triggerChildAddedCallback(item)
        })

        this.getRef()
            .once('value', snapshot => {
                this.allItems = []
                snapshot.forEach(childSnapshot => {
                    let item = childSnapshot.val()
                    item.key = childSnapshot.key
                    item = this.preprocessItem(item)
                    this.allItems.push(Object.assign(this.getBaseObject(), item))
                })
                if (this.sort) {
                    this.allItems.sort(this.sort);
                }
                this.doneLoadValue = true
                this.triggerCallback()
                this.triggerChildAddedCallback()
            });

        this.getRef()
        .on('child_changed', snapshot => {
            if (!this.doneLoadValue) {
                // We wait for 'value' listener to trigger first to initialize the
                // orders array. Adding item one by one from 'child_added' to initialize
                // orders array will trigger excessive and unnecessary render()
                return
            }

            let item = snapshot.val()
            item.key = item.key
            item = this.preprocessItem(item)
            item = Object.assign(this.getBaseObject(), item)

            this.updateMainDataSet(item, true)
            this.triggerCallback()
        })

        this.getRef().on('child_removed', snapshot => {
            let item = snapshot.val()
            item.key = item.key
            this.mainDataSetRemoveItem(item)
            this.triggerCallback()
            this.triggerChildRemovedCallback(item)
            this.logChildRemoved && this.logChildRemoved(item)
        })
    }

    mainDataSetRemoveItem = (item, sortAfterChange = false) => {
        let index = this.allItems.findIndex(oldItem => item.id == oldItem.id)
        if (index > -1) {
            this.allItems.splice(index, 1)
            if (sortAfterChange) {
                this.sortDataSet()
            }
        }
    }
    updateMainDataSet = (item, sortAfterChange = false) => {
        let index = this.allItems.findIndex(oldItem => item.id == oldItem.id)
        let removeCount = 1
        if (index > -1) {
            // We remove the existing item and replace with
            // updated item
            removeCount = 1
        }
        else if (index === -1) {
            // Nothing to remove
            removeCount = 0

            // Add to end of array
            index = this.allItems.length - 1
        }

        this.allItems.splice(index,removeCount, item)
        if (sortAfterChange) {
            this.sortDataSet()
        }
    }

    sortDataSet = () => {
        if (this.sort) {
            this.allItems.sort(this.sort)
        }
    }

    /**
     * Notify all listeners on firebase 'child_added' triggered
     * Difference between 'triggerCallback' and 'triggerChildAddedCallback'
     * is that
     * 1. 'triggerChildAddedCallback' will always return new item only, while
     *    'triggerCallback' will return all objects and listeners need to store state
     *    internally and manual peform diff to find out which are old items and which
     *    are new items
     *
     * @param {Object} item
     */
    triggerChildAddedCallback = (item, callbackKey) => {
        if (!this.doneLoadValue) {
            // We wait for 'value' listener to trigger first to initialize the
            // orders array. Adding item one by one from 'child_added' to initialize
            // orders array will trigger excessive and unnecessary render()
            return
        }

        // No item, should be first time adding callback,
        // return allItems
        if (!item) {
            item = this.allItems
        }
        if (!callbackKey) {
            // Trigger all callbacks
            Object.keys(this.childAddedCallbackMap).forEach(key => {
                this.childAddedCallbackMap[key](item)
            })
        }
        else if (this.childAddedCallbackMap[callbackKey]) {
            this.childAddedCallbackMap[callbackKey](item)
        }
    }
    /**
     * Notify all listeners on firebase 'child_removed' triggered
     *
     * @param {Object} item
     */
    triggerChildRemovedCallback = (item, callbackKey) => {
        if (!this.doneLoadValue) {
            // We wait for 'value' listener to trigger first to initialize the
            // orders array. Adding item one by one from 'child_added' to initialize
            // orders array will trigger excessive and unnecessary render()
            return
        }

        // No item
        if (!item) {
            return
        }
        if (!callbackKey) {
            // Trigger all callbacks
            Object.keys(this.childRemovedCallbackMap).forEach(key => {
                this.childRemovedCallbackMap[key](item)
            })
        }
        else if (this.childRemovedCallbackMap[callbackKey]) {
            this.childRemovedCallbackMap[callbackKey](item)
        }
    }
    triggerCallback = (callbackKey, fromApi) => {
        // Data not ready, no point triggering with empty dataset and
        // cause unnecessary render. This one only handle load data from Firebase.
        // Load from API handled differently
        if (!fromApi && !this.doneLoadValue) {
            return
        }

        // Callback triggered from attempt to load data from API,
        // skip if API result not ready
        else if (fromApi && !this.doneLoadFromApi) {
            return
        }
        if (!callbackKey) {
            // Trigger all callbacks
            Object.keys(this.callbackMap).forEach(key => {
                this.callbackMap[key](this.allItems)
            })
        }
        else if (this.callbackMap[callbackKey]) {
            this.callbackMap[callbackKey](this.allItems)
        }
        if (this.getDataChangedEventKey()) {
            $(document).trigger(this.getDataChangedEventKey())
        }
    }
    triggerSingleItemCallback = (id, callbackKey) => {
        if (!this.singleLoadedItems[id]) {
            return
        }
        if (!callbackKey) {
            // Trigger all callbacks for the item with matching id
            (Object.keys(this.singleItemCallbackMap[id]) || []).forEach(key => {
                this.singleItemCallbackMap[id][key](this.singleLoadedItems[id])
            })
        }
        else if (this.singleItemCallbackMap[id] && this.singleItemCallbackMap[id][callbackKey]) {
            this.singleItemCallbackMap[id][callbackKey](this.singleLoadedItems[id])
        }
    }
    /**
     *
     * @param {int} id - The id of object to be used in REST API URL
     * @param {Object} obj - The data to be POST
     * @param {Function} callback - Callback on API success/complete
     */
    update = (id, obj, callback) => {
        let callbackFire = false
        $.ajax({
            url     : this.getUpdateUrl(id),
            type    : 'post',
            data    : obj,
            success : updatedObj => {
                updatedObj = this.parseRawApiResponse(updatedObj)
                if (!Array.isArray(updatedObj)) {
                    updatedObj = [updatedObj]
                }
                updatedObj.forEach(item => {
                    item.key = item.id
                    item = this.preprocessItem(item)

                    this.updateMainDataSet(item)
                })

                this.sortDataSet()

                this.triggerCallback()
                if (!callbackFire) {
                    callbackFire = true
                    callback && callback(updatedObj)
                }
            }
        })
        .always(() => {
            if (!callbackFire) {
                callbackFire = true
                callback && callback(false)
            }
        })
    }
}